import { default as React } from "react"
import { v4 as uuidv4 } from "uuid"
import Score from "./score"
import { StaticImage } from "gatsby-plugin-image"

const BeerInfo = props => {
  return (
    <div className="my-0 mx-auto md:w-1/3 min-h-min max-h-fit text-center pt-0 pb-6 rounded overflow-hidden shadow-lg">
        <div className="px-2 py-4">
          <a className="no-underline text-black" href="/taproom"><div className="font-bold text-xl mb-2 h-12">{props.name}</div>
          <Score beer={true} score={props.score} />
          </a>
          <p className="text-gray-700 text-base mb-0">{props.type}</p>
          <p className="text-gray-700 text-base mb-0">{props.brewery}</p>
          <p className="text-gray-700 text-base mb-0">{props.abv}%</p>
          <div className="px-2 pt-4 pb-2 h-36">
            {props.tags.map(tag => {
              return (
                <span
                  key={uuidv4()}
                  className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold mr-2 mb-2 hover:bg-gray-400"
                >
                  <a
                    href="/taproom"
                    onClick={() => props.onSelectTag(tag)}
                    className="text-center text-gray-700 no-underline mx-2 my-2"
                  >
                    {tag}
                  </a>
                </span>
              )
            })}
          </div>
          {props.path && <a href={props.path}>Go To Article</a>}
          {props.untappdPath && <a className="flex pt-2" target="_blank" href={props.untappdPath}>
                <StaticImage
                  key="untappd"
                  id="untappdlogocolor"
                  className="inline-flex md:w-6 w-4 mb-1 my-0 mx-auto text-center"
                  src="../images/untappdcolor.png"
                  alt="untappd color logo"
                  layout="fullWidth"
                  loading="eager"
                /></a>}
        </div>
    </div>
  )
}

export default BeerInfo
